import React, { useState } from 'react';
import { TYPES, COINS } from '../data/types';
import Coin from '../components/Coin';
import './Landing.css';

const FEATURED = ['INTJ','INFJ','ENFP','ISTP','ENTJ','INFP'];

export default function Landing({ onStart }) {
  const [hovered, setHovered] = useState(null);
  const types = Object.values(TYPES);

  return (
    <div className="land">
      {/* Nav */}
      <nav className="l-nav">
        <div className="l-nav-inner">
          <div className="l-logo">
            <span className="l-logo-mark">◈</span>
            <span className="l-logo-text">prismself<span className="l-logo-dot">.com</span></span>
          </div>
          <button className="l-nav-btn" onClick={onStart}>Start Free Test</button>
        </div>
      </nav>

      {/* Hero */}
      <section className="l-hero">
        <div className="l-hero-inner">
          <div className="l-badge fade-up">✦ Free · Instant · No account needed</div>
          <h1 className="l-title fade-up">
            Reveal the hidden side<br/>
            <em>of your personality</em>
          </h1>
          <p className="l-sub fade-up">
            Most people only see their surface. This test goes deeper —
            30 precise questions to surface the traits that quietly shape every decision you make.
          </p>
          <div className="l-hero-actions fade-up">
            <button className="l-btn-primary" onClick={onStart}>
              Discover My Hidden Side →
            </button>
            <p className="l-note">Takes 5 minutes · Results are instant</p>
          </div>

          {/* Featured coins */}
          <div className="l-coins-preview fade-up">
            {FEATURED.map((code, i) => (
              <div
                key={code}
                className="l-coin-wrap"
                style={{ animationDelay: `${i * 0.07}s`, zIndex: FEATURED.length - i }}
                onMouseEnter={() => setHovered(code)}
                onMouseLeave={() => setHovered(null)}
              >
                <Coin type={code} coin={COINS[code]} size={88} />
                {hovered === code && (
                  <div className="l-coin-tooltip">
                    <strong>{code}</strong>
                    <span>{TYPES[code].name}</span>
                    <span className="l-tip-metal">{COINS[code].metal} · {COINS[code].rarity}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats bar */}
      <div className="l-stats-bar">
        <div className="l-stats-inner">
          {[['16','Personality types'],['30','Precise questions'],['5 min','Average time'],['Free','Always']].map(([v,l]) => (
            <div key={l} className="l-stat">
              <span className="l-stat-val">{v}</span>
              <span className="l-stat-label">{l}</span>
            </div>
          ))}
        </div>
      </div>

      {/* How it works */}
      <section className="l-section">
        <div className="l-container">
          <div className="l-sec-head">
            <div className="l-tag">How it works</div>
            <h2 className="l-sec-title">Three steps to know yourself</h2>
          </div>
          <div className="l-steps">
            {[
              { n:'01', icon:'📝', title:'Answer 30 questions', desc:'Simple A or B choices. No right or wrong. Trust your first instinct.' },
              { n:'02', icon:'🪙', title:'Your coin is revealed', desc:'Your personality is minted as a unique gold coin — one of 16. Each one tells a different truth.' },
              { n:'03', icon:'💌', title:'Receive your full profile', desc:'Enter your email for a complete deep-dive analysis of your hidden strengths and blind spots.' },
            ].map(s => (
              <div key={s.n} className="l-step">
                <div className="l-step-n">{s.n}</div>
                <div className="l-step-icon">{s.icon}</div>
                <h3 className="l-step-title">{s.title}</h3>
                <p className="l-step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 16 coins collection */}
      <section className="l-section l-section-warm">
        <div className="l-container">
          <div className="l-sec-head">
            <div className="l-tag">The Collection</div>
            <h2 className="l-sec-title">16 Personality Coins</h2>
            <p className="l-sec-sub">One is minted specifically for you</p>
          </div>
          <div className="l-coins-grid">
            {types.map(t => (
              <div key={t.code} className="l-coin-card" onClick={onStart}>
                <div className="l-coin-ring" style={{ boxShadow: `0 0 0 3px ${t.coin.color}` }}>
                  <Coin type={t.code} coin={t.coin} size={68} />
                </div>
                <div className="l-coin-info">
                  <div className="l-coin-code">{t.code}</div>
                  <div className="l-coin-name">{t.name}</div>
                  <div className="l-coin-metal">{t.coin.rarity}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:'40px' }}>
            <button className="l-btn-primary" onClick={onStart}>Find Mine →</button>
          </div>
        </div>
      </section>

      {/* Quote */}
      <section className="l-section" style={{ background:'var(--bg2)' }}>
        <div className="l-container">
          <blockquote className="l-quote">
            <span className="l-quote-mark">"</span>
            <p>Knowing yourself is the beginning of all wisdom.</p>
            <cite>— Aristotle</cite>
          </blockquote>
        </div>
      </section>

      {/* CTA */}
      <section className="l-section">
        <div className="l-container">
          <div className="l-cta">
            <div className="l-cta-coin">
              <Coin type="INTJ" coin={COINS['INTJ']} size={96} />
            </div>
            <h2 className="l-cta-title">What does your coin say about you?</h2>
            <p className="l-cta-sub">5 minutes to uncover the patterns shaping your decisions, relationships and potential.</p>
            <button className="l-btn-primary l-btn-lg" onClick={onStart}>
              Start Now — It's Free →
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="l-footer">
        <div className="l-container">
          <div className="l-footer-inner">
            <div className="l-footer-logo">◈ prismself<span style={{ color:'var(--gold)' }}>.com</span></div>
            <div className="l-footer-links">
              <a href="/privacy">Privacy</a>
              <a href="/terms">Terms</a>
              <a href="/unsubscribe">Unsubscribe</a>
            </div>
            <p className="l-footer-copy">© 2025 prismself.com</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
